import * as fromCarsReducer from './VehiclesReducer';
import * as fromUserReducer from './UserReducer';
import * as fromViewManagementReducers from './ViewManagementReducer';
import * as fromPOIReducer from './POIReducer';
import * as fromHistoryReducer from './HistoryReducer';
import * as fromAOIReducer from './AOIReducer';
import * as fromErrorReducer from './ErrorReducer';
import * as fromMapReducer from './MapReducer';
import * as fromFleetReducer from './FleetReducer';
import * as fromAlertReducer from './AlertReducer';
import * as fromNotificationReducer from './NotificationReducer';
import * as fromReportReducer from './ReportReducer';
import * as fromContractReducer from './ContractReducer';
import * as fromTerminalInstallationReducer from './TerminalInstallationReducer';
import {Types as TerminalInstallationTypes} from '../../Models/TerminalInstallationModel';
import {historyCollisionReducer, HistoryCollisionState} from './CollisionReducer'
import {infinityTableReducer, State as InfinityTableState} from "Redux/Reducers/InfinityTeableReducer";


import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';
import * as ActionTypes from 'Redux/Actions/EnumTypes/ActionEnumTypes';
import {latestDataframesFormReducer, LatestDataframesFormState} from "Redux/Reducers/LatestDataframesForm.Reducer";

export type RootState = {
    vehiclesStore: fromCarsReducer.State;
    userStore: fromUserReducer.State;
    viewManagementStore: fromViewManagementReducers.State;
    poiStore: fromPOIReducer.State;
    historyStore: fromHistoryReducer.State;
    aoiStore: fromAOIReducer.State;
    errorStore: fromErrorReducer.State;
    mapStore: fromMapReducer.State;
    fleetStore: fromFleetReducer.State;
    alertStore: fromAlertReducer.State;
    notificationStore: fromNotificationReducer.State;
    reportStore: fromReportReducer.State;
    terminalInstallationStore: fromTerminalInstallationReducer.State;
    contractStore: fromContractReducer.State;
    historyCollision: HistoryCollisionState,
    form: any,
    infinityTableStore: InfinityTableState
    latestDataframesForm: LatestDataframesFormState,
};

const rootReducer = combineReducers<RootState>({
    vehiclesStore: fromCarsReducer.carsReducer,
    userStore: fromUserReducer.userReducer,
    viewManagementStore: fromViewManagementReducers.viewManagementReducer,
    poiStore: fromPOIReducer.poiReducer,
    historyStore: fromHistoryReducer.historyReducer,
    aoiStore: fromAOIReducer.aoiReducer,
    errorStore: fromErrorReducer.errorReducer,
    mapStore: fromMapReducer.mapReducer,
    fleetStore: fromFleetReducer.fleetReducer,
    alertStore: fromAlertReducer.alertReducer,
    notificationStore: fromNotificationReducer.notificationReducer,
    reportStore: fromReportReducer.reportReducer,
    terminalInstallationStore: fromTerminalInstallationReducer.terminalInstallationReducer,
    contractStore: fromContractReducer.contractReducer,
    form: formReducer,
    router: routerReducer,
    historyCollision: historyCollisionReducer,
    infinityTableStore: infinityTableReducer,
    latestDataframesForm: latestDataframesFormReducer
} as any);

const appReducer = (state, action) => {
    if (action.type === ActionTypes.User.LOG_OUT) {
        state = undefined;
    } else if (action.type === ActionTypes.ERORR.UNAUTHORIZED_USER) {
        state.form.loginForm.values.password = '';
    }

    if (action.type === ActionTypes.History.CLEAR_HISTORY_RIDES_SUBMISSION && state.form.searchRidesForm) {
      delete state.form.searchRidesForm.submitSucceeded
    }

    return rootReducer(state, action);
};
export default appReducer;



// WEBPACK FOOTER //
// ./src/Redux/Reducers/_RootReducer.ts